import React, { Component } from "react";
import { string, func, array } from "prop-types";
import { Tree, Switch, Select, Icon } from "antd";
import _ from "lodash";

import "./selectorDuid.css";
const { TreeNode } = Tree;
const { Option } = Select;

const keysName = {
  regionid: "Region",
  portfolioid: "Portfolio",
  stationid: "Station",
  duid_name: "Duid"
};

class SelectorDuid extends Component {
  state = {
    processsedItems: [],
    treeData: [],
    checkedKeys: this.props.items
      .filter(i => i.isChecked)
      .map(i => this.getUniqueKey("duid_name", i)),
    regionid: {
      enabled: true,
      filterItems: [],
      showFilter: false
    },
    portfolioid: {
      enabled: true,
      filterItems: [],
      showFilter: false
    },
    stationid: {
      enabled: true,
      filterItems: [],
      showFilter: false
    },
    duid_name: {
      enabled: true,
      filterItems: [],
      showFilter: false
    },
    keysOrder: ["regionid", "portfolioid", "stationid", "duid_name"],
    showFilterSelection: false
  };

  isKeyEnabled = key => {
    return this.state[key].enabled;
  };

  hasFilters = key => {
    const { filterItems } = this.state[key];
    return filterItems && filterItems.length > 0;
  };

  isItemVisible = (key, itemValue) => {
    const { filterItems } = this.state[key];
    return filterItems.indexOf(itemValue) >= 0;
  };

  getChildKey(currentKey) {
    switch (currentKey) {
      case "regionid":
        return this.isKeyEnabled("portfolioid")
          ? "portfolioid_unique"
          : this.getChildKey("portfolioid");
      case "portfolioid":
      case "portfolioid_unique":
        return this.isKeyEnabled("stationid")
          ? "stationid"
          : this.getChildKey("stationid");
      case "stationid":
        return this.isKeyEnabled("duid_name")
          ? "duid_name"
          : this.getChildKey("duid_name");
      default:
        return null;
    }
  }

  getUniqueKey(currentKey, item) {
    if (currentKey === "portfolioid" && this.isKeyEnabled("regionid")) {
      //portfolioid-NSW1-AGL
      return `${currentKey}-${item["regionid"]}-${item[currentKey]}`;
    } else if (currentKey === "duid_name") {
      //duid_name-47
      return `${currentKey}-${item["value"]}`; //value is element no
    } else {
      //key-value
      return `${currentKey}-${item[currentKey]}`;
    }
  }

  getAllKeys(tree) {
    let keys = [];
    tree.forEach(n => {
      keys.push(n.key);
      if (n.children && n.children.length > 0)
        keys.push(this.getAllKeys(n.children));
    });

    return keys;
  }

  getFirstLevelKey = () => {
    const { keysOrder } = this.state;
    for (let i = 0; i < keysOrder.length; i++) {
      const k = keysOrder[i];
      if (this.isKeyEnabled(k)) return k;
    }
    return null;
  };

  getArrayByKey = key => {
    const { items } = this.props;
    let arr = [];
    items.forEach(i => {
      const value = i[key];
      if (arr.indexOf(value) < 0) arr.push(value);
    });
    return arr;
  };

  getItemVisibility = item => {
    const self = this;
    const filters = ["regionid", "portfolioid", "stationid"];
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      if (
        self.hasFilters(filter) &&
        !self.isItemVisible(filter, item[filter])
      ) {
        return false;
      }
    }
    return true;
  };

  getTreeNodeElements = (filteredItems, parentKey, parentValue) => {
    const currentKey = this.getChildKey(parentKey);

    const filteredObj = this.getFilteredObj(
      filteredItems.filter(i => i[parentKey] === parentValue),
      currentKey
    );

    const hasChildren = this.getChildKey(currentKey) !== null;

    let treeNodes = [];
    Object.keys(filteredObj)
      .sort()
      .forEach(itemValue => {
        const item = filteredObj[itemValue];
        treeNodes.push({
          title: itemValue,
          key: this.getUniqueKey(currentKey, item),
          children: hasChildren
            ? this.getTreeNodeElements(filteredItems, currentKey, itemValue)
            : []
        });
      });
    //console.log('gettreenodes', filteredObj, key, treeNodes);
    return treeNodes;
  };

  getFilteredObj = (matchingItems, key) => {
    let obj = {};
    matchingItems.forEach(i => {
      const value = i[key];
      if (!obj[value]) obj[value] = i;
    });
    return obj;
  };

  resetTree = () => {
    const { items } = this.props;
    //process items for visibility check first
    let filteredItems = []; //processed filtered items
    items.forEach(i => {
      if (this.getItemVisibility(i))
        filteredItems.push({
          ...i,
          portfolioid_unique: `${i["portfolioid"]} (${i["regionid"]})`
        });
    });

    let tree = [];

    const firstLevelKey = this.getFirstLevelKey();
    let firstLevelItems = this.getFilteredObj(filteredItems, firstLevelKey);
    const hasChildren = this.getChildKey(firstLevelKey) !== null;

    Object.keys(firstLevelItems)
      .sort()
      .forEach(itemValue => {
        //const item = this.getFirstItemByKeyValue(firstLevelKey, itemValue);c
        const item = firstLevelItems[itemValue];
        tree.push({
          title: itemValue,
          key: this.getUniqueKey(firstLevelKey, item),
          children: hasChildren
            ? this.getTreeNodeElements(filteredItems, firstLevelKey, itemValue)
            : []
        });
      });

    const allKeys = _.flattenDeep(this.getAllKeys(tree));

    this.setState(
      prevState => ({
        treeData: tree,
        checkedKeys: prevState.checkedKeys.filter(k => allKeys.indexOf(k) >= 0) //remove checked keys that are filtered out now
      }),
      () => this.onUpdateParentElement()
    );
  };

  componentWillMount() {
    this.resetTree();
  }

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode {...item} />;
    });
  };

  onToggleKey = key => () => {
    this.setState(
      prevState => ({
        [key]: {
          ...prevState[key],
          enabled: !prevState[key].enabled
        }
      }),
      () => this.resetTree()
    );
  };

  onChangeFilter = key => values => {
    this.setState(
      prevState => ({
        [key]: {
          ...prevState[key],
          showFilter: false,
          filterItems: values
        }
      }),
      () => this.resetTree()
    );
  };

  addFilter = () => {
    this.setState(prevState => ({
      showFilterSelection: true
    }));
  };

  onChangeFilterType = value => {
    this.setState(prevState => ({
      showFilterSelection: false,
      [value]: {
        ...prevState[value],
        showFilter: true
      }
    }));
  };

  getCheckedElements = () => {
    const { checkedKeys } = this.state;
    //const { items } = this.props;
    const match = checkedKeys
      .filter(i => _.startsWith(i, "duid_name-"))
      .map(i => i.replace("duid_name-", ""));
    //const elements = items.filter(i => match.indexOf(i["duid_name"]) >= 0).map(i => i.value);
    //  console.log('ELEMENTS', match);
    return match;
  };

  onCheck = checkedKeys => {
    //   console.log("onCheck", checkedKeys);

    this.setState({ checkedKeys }, () => this.onUpdateParentElement());
  };

  onUpdateParentElement = () => {
    this.props.onToggleItems(this.getCheckedElements());
  };

  render() {
    const { className } = this.props;
    const { treeData } = this.state;
    //console.log("duidselector", this.state);
    return (
      <div className={`cp-selector-duid test-selector-duid ${className}`}>
        <div className="keys-section">
          {["regionid", "portfolioid", "stationid"].map(k => (
            <span key={k}>
              {/*<label>{keysName[k]}</label>*/}
              <Switch
                checkedChildren={keysName[k]}
                unCheckedChildren={keysName[k]}
                className="keys-switch"
                size="default"
                defaultChecked={this.state[k].enabled}
                onChange={this.onToggleKey(k)}
              />
            </span>
          ))}
        </div>
        <div className="filter-section">
          {["regionid", "portfolioid", "stationid"]
            .filter(
              k =>
                this.state[k].showFilter ||
                (this.state[k].filterItems &&
                  this.state[k].filterItems.length > 0)
            )
            .map(k => (
              <div key={k}>
                <label>{keysName[k]} filters</label>
                <Select
                  allowClear={true}
                  autoFocus={true}
                  mode="multiple"
                  placeholder={`select a ${keysName[k].toLowerCase()}`}
                  defaultValue={this.state[k].filterItems}
                  style={{ width: "100%" }}
                  onChange={this.onChangeFilter(k)}
                >
                  {this.getArrayByKey(k)
                    .sort()
                    .map(item => <Option key={item}>{item}</Option>)}
                </Select>
              </div>
            ))}

          {!this.state.showFilterSelection && (
            <a className="add-filter-link" onClick={this.addFilter}>
              <Icon type="plus" /> add filter
            </a>
          )}
          {this.state.showFilterSelection && (
            <div className="filter-selection">
              <Select
                style={{ width: "100%" }}
                placeholder="select filter type"
                onChange={this.onChangeFilterType}
              >
                {["regionid", "portfolioid", "stationid"].map(i => (
                  <Option key={i}>{keysName[i]} filter</Option>
                ))}
              </Select>
            </div>
          )}
        </div>

        <Tree
          //defaultExpandAll={true}
          checkable={true}
          //checkStrictly={true}
          onCheck={this.onCheck}
          checkedKeys={this.state.checkedKeys}
          selectedKeys={[]}
        >
          {this.renderTreeNodes(treeData)}
        </Tree>
      </div>
    );
  }
}

SelectorDuid.propTypes = {
  className: string,
  items: array.isRequired,
  onToggleItems: func.isRequired
};

export default SelectorDuid;



// WEBPACK FOOTER //
// ./src/views/components/selector_duid/SelectorDuid.jsx